var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.notes),function(note,i){return _c('div',{key:i,attrs:{"prominent":"","text":"","color":"red"}},[_c('note',{attrs:{"note":note,"deletable":"","editable":false,"no-tab-focus":_vm.noTabFocus},on:{"deleted":_vm.deleteNote}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }